import { useEffect, useState } from 'react'
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'

export default function DarkModeToggle(props) {
  let size = props.size ?? "h-9 w-9";
  const [isDark, setIsDark] = useState(false)
  
  useEffect(() => {
    const saved = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const shouldBeDark = saved === 'dark' || (!saved && prefersDark)

    setIsDark(shouldBeDark)
    document.documentElement.classList.toggle('dark', shouldBeDark)
  }, [])

  const toggleTheme = () => {
    const newTheme = isDark ? 'light' : 'dark'
    setIsDark(!isDark)
    document.documentElement.classList.toggle('dark', !isDark)
    localStorage.setItem('theme', newTheme)
  }

  return (
    <button
      onClick={toggleTheme}
      className={"p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700 bg-gray-200/30 dark:bg-gray-700/30 transition cursor-pointer" + props.className}
      aria-label="Toggle dark mode"
    >
      {isDark ? (
        <SunIcon className={"text-white " + size} />
      ) : (
        <MoonIcon className={"text-black " + size}/>
      )}
    </button>
  )
}
